export default __webpack_public_path__ + "static/media/world_green.42244fa6.svg";